import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { validationsQuestionsDynamiques } from 'src/app/shared/questionnaire.metadata';
import { ValidationService } from '../../../../shared/validation/validation.service';
import { FormulaireService } from '../../../formulaire.service';
import { ModeRenduService } from '../../../mode-rendu/mode-rendu.service';

@Component({
  selector: 'bis-lieux-autr',
  templateUrl: './lieux-autr.component.html',
  styleUrls: ['./lieux-autr.component.css']
})
export class LieuxAutrComponent implements OnInit, OnDestroy {
  public rootForm: UntypedFormGroup;
  step: number = 0;
  @Input()
  erreursMap: Map<string, string>;

  private subLieuxAutr: Subscription;
  private valeurTableauA4i_1: number[] = [];
  private valeurTableauA4i_2: number[] = [];
  private valeurTableauA4i_3: number[] = [];

  constructor(
    private formulaireService: FormulaireService,
    private validationService: ValidationService,
    public modeRenduService: ModeRenduService
  ) {
    this.rootForm = this.formulaireService.getRootForm();
    if (! this.lieuxAutr) {
      (this.rootForm.get('moyens') as UntypedFormGroup).setControl('lieuxAutr', new UntypedFormArray([]));
    }
   }

  ngOnInit(): void {
    setTimeout(() => {
      //Controles bloquants
      for (let index = 0; index < this.lieuxAutr.length; index++) {
        this.ajoutValidateurCroiseLieuxAutr(index);
        this.lieuxAutr.controls[index].updateValueAndValidity();
      }

      // Tri apres rechargement questionnaire
      this.trierLieuxAutr();
    
      // Calcul des totaux lieux autr
      this.subLieuxAutr = this.lieuxAutr.valueChanges.pipe(distinctUntilChanged(),debounceTime(100)).subscribe(valeur => {
          if (valeur instanceof Array) {

            this.valeurTableauA4i_1 = [];
            this.valeurTableauA4i_2 = [];
            this.valeurTableauA4i_3 = [];
            
            valeur.forEach((lieux, index) => {
              //Calcul totaux auto A4i
              this.calculAutoTotauxA4i(index, this.valeurTableauA4i_1, 'aaLieuAutrNbPerm', 'aaLieuAutrNbPermTot');      
              this.calculAutoTotauxA4i(index, this.valeurTableauA4i_2, 'aaLieuAutrNbPermEtp', 'aaLieuAutrNbPermEtpTot');      
              this.calculAutoTotauxA4i(index, this.valeurTableauA4i_3, 'aaLieuAutrNbVict', 'aaLieuAutrNbVictTot');      
            });
          }
        });
      this.lieuxAutr.updateValueAndValidity();
    }, 1000);

  }

  ngOnDestroy(): void {
    if (this.subLieuxAutr) {
      this.subLieuxAutr.unsubscribe();
    }
  }

  get lieuxAutr() {
    return this.rootForm.get('moyens').get('lieuxAutr') as UntypedFormArray;
  }

  public get formulaire(): UntypedFormGroup {
    return this.rootForm.get('moyens') as UntypedFormGroup;
  }

  public ajouterLieuxAutr() {
    // on récupère le nombre total avant ajout
    let nbLieux = this.formulaire.get('aaLieuAutrNb').value;

    // Pour les validators, on utilise ce qui est dans le questionnaire.metadata
    this.lieuxAutr.push(new UntypedFormGroup({
      aaLieuAutrRang: new UntypedFormControl(this.lieuxAutr.length, Validators.required),
      aaLieuAutrDet: new UntypedFormControl('', validationsQuestionsDynamiques.get('aaLieuAutrDet')),
      aaLieuAutrCodCom: new UntypedFormControl('', validationsQuestionsDynamiques.get('aaLieuAutrCodCom')),
      aaLieuAutrQp: new UntypedFormControl('', validationsQuestionsDynamiques.get('aaLieuAutrQp')),
      aaLieuAutrNbPerm: new UntypedFormControl(null, validationsQuestionsDynamiques.get('aaLieuAutrNbPerm')),
      aaLieuAutrNbPermEtp: new UntypedFormControl(null, validationsQuestionsDynamiques.get('aaLieuAutrNbPermEtp')),
      aaLieuAutrNbVict: new UntypedFormControl(null, validationsQuestionsDynamiques.get('aaLieuAutrNbVict'))
    }));
    this.step = this.lieuxAutr.length - 1 ;
    this.ajoutValidateurCroiseLieuxAutr(this.lieuxAutr.length - 1);

    // on incrémente le nombre total de lieux
    this.formulaire.get('aaLieuAutrNb').setValue(++nbLieux);
  }

  private ajoutValidateurCroiseLieuxAutr (index: number) {
    const currentForm: UntypedFormGroup = this.lieuxAutr.controls[index] as UntypedFormGroup;
    currentForm.setValidators([
      this.validationService.ctrlA76Autr,
      this.validationService.ctrlA77Autr
    ]);
  }

  public supprimerLieuxAutr(index?: number) {
    if (index >= 0) {
      const lieuxValeur = this.lieuxAutr.controls[index].value;
      if (confirm(`Êtes vous sûr de supprimer ${lieuxValeur['aaLieuAutrCodCom']} ?`)) {
        this.lieuxAutr.removeAt(index);
      }
    } else {
      this.lieuxAutr.removeAt(this.lieuxAutr.length - 1);
    }
    // On maj les rangs
    this.majRangs();
    // on met à jour le nombre total de lieux
    this.formulaire.get('aaLieuAutrNb').setValue(this.lieuxAutr.controls.length);
  }

  public setStep(index: number): void {
    this.step = index;
  }

  private trierLieuxAutr(): void {
    this.lieuxAutr.controls.sort((a, b) => {
      if (a.get('aaLieuAutrRang').value < b.get('aaLieuAutrRang').value) {
            return -1;
      } else if (a.get('aaLieuAutrRang').value > b.get('aaLieuAutrRang').value) {
            return 1;
      } else {
            return 0;
      }
    });
  }

  private majRangs(): void {
    for (let index = 0; index < this.lieuxAutr.length; index++) {
      this.lieuxAutr.controls[index].get('aaLieuAutrRang').setValue(index);
    }
    this.trierLieuxAutr();
  }

  private calculAutoTotauxA4i(index: number, tabBoucle: number[], varBoucle: string, totBoucle: string): void {
    tabBoucle.splice(index,1,this.lieuxAutr.controls[index].get(varBoucle).value);
    let sum = tabBoucle.reduce((a,b)=>a+b,0);
    this.formulaire.get(totBoucle).setValue(sum);
  }

}
